import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { Observable, filter, map, startWith } from 'rxjs';

import { BrandCampaign } from '@hiptraveler/data-access/api';
import { BrandState } from '@hiptraveler/data-access/brand';
import { ExperienceFinderStateService } from '@hiptraveler/features/experience-finder';
import { AppListenerService, currentLang, getPathname, isBrandIframeWidget, promiseDelay } from '@hiptraveler/common';

// Legacy functions
import { Store } from '@ngxs/store';
import { delay, skip, takeUntil } from 'rxjs';
import { concat } from 'lodash';

import { ListItem } from '../../modules/shell--search-page-root/filters/list-items';
import { isWidget } from '@hiptraveler/common';
import { FiltersStateService } from '../..//modules/shell--search-page-root/filters/common';
import { getWindowRef, appWindowObjectPrefix } from '@hiptraveler/common';

function getFiltersStateService(): FiltersStateService {
  return getWindowRef()[`${appWindowObjectPrefix}_search_filters_state_service_ref`];
}

@Component({
  selector: 'experience-finder',
  templateUrl: './experience-finder.component.html',
  styleUrls: ['./experience-finder.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExperienceFinderComponent implements OnInit {

  @Select(BrandState.brandCampaign) brandCampaign$: Observable<Partial<BrandCampaign> | null>;

  constructor(
    private router: Router,
    public appListener: AppListenerService,
    public stateService: ExperienceFinderStateService,

    // Legacy functions
    private store: Store
  ) { }

  ngOnInit(): void {
    this.stateService.submitDispatchListener();

    // Legacy functions
    
    const interval = setInterval(() => {
      const filtersState = getFiltersStateService();
      if (filtersState) {
        clearInterval(interval);
        this.legacyFunctions();
      }
    }, 100);
  }

  get activeBubble$(): Observable<boolean> {
    return this.appListener.clientWidth$.pipe(
      map((clientWidth: number) => clientWidth < 1100)
    );
  }

  get iframeWidget$(): Observable<any> {
    return this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
      map(e => e.url),
      startWith(this.router.url),
      map(url => getPathname(url)),
      map(e => e === `/${currentLang()}` && isBrandIframeWidget())
    )
  }

  // Legacy functions
  private async legacyFunctions(): Promise<void> {

    const filtersState = getFiltersStateService();

    if (isWidget() || !filtersState) return;
    
    this.store.select(BrandState.clientProfile).pipe(
      delay(100),
      filter(e => !!e?.travelStyle?.filter(Boolean)?.length),
      takeUntil( this.stateService.overlayState$.pipe(map(e => !e), skip(1)) )
    ).subscribe(clientProfile => {
      const travelStyle = clientProfile!.travelStyle;
      const experiences = this.store.selectSnapshot(BrandState.experiences);

      const filteredExperiences = experiences?.filter((experience) => {
        return travelStyle?.includes(experience?.code || '');
      });;

      const _activities: ListItem[] = filteredExperiences?.filter(e => e.category === 'activity')?.map(e => ({
        type: e?.category === 'activity' ? 'activities' 
          : e?.category === 'experience' ? 'exp' : 'travelStyle',
        name: e?.name || '',
        value: e?.code || ''
      })) || [];
      const _experiences: ListItem[] = filteredExperiences?.filter(e => e.category === 'experience')?.map(e => ({
        type: e?.category === 'activity' ? 'activities' 
          : e?.category === 'experience' ? 'exp' : 'travelStyle',
        name: e?.name || '',
        value: e?.code || ''
      })) || [];
      const _travelStyles: ListItem[] = filteredExperiences?.filter(e => e.category === 'travelStyle')?.map(e => ({
        type: e?.category === 'activity' ? 'activities' 
          : e?.category === 'experience' ? 'exp' : 'travelStyle',
        name: e?.name || '',
        value: e?.code || ''
      })) || [];

      setTimeout(() => {
        filtersState.selectedItems$$.next(_activities);
        filtersState.selectedTravelStyles$$.next(concat(_experiences, _travelStyles));
      }, 1000);
    });
  }

}
